<template>
  <div ref="vm" class="ui-more-layout fun-ctrl">
    <slot></slot>
    <ui-icon class="ui-more" v-bind="attrs" type="d-r" v-if="showArow" />
  </div>
  <ui-floating
    class="more-float"
    :dire="dire"
    :class="{ show: showOption, [floatClass]: true }"
    :isTransform="isTransform"
    :mount="mountel"
    :refer="vm"
    ref="floatVM"
  >
    <div
      class="option"
      :class="{ selected: selected === option.value }"
      v-for="option in options"
      @click="option.value !== selected && clickHandler(option)"
    >
      <span v-if="$slots.option" class="pre-icon">
        <slot
          name="option"
          :data="option.value"
          :selected="selected === option.value"
        />
      </span>
      <template v-else>
        {{ option.label }}
      </template>
    </div>
  </ui-floating>
</template>

<script>
import { defineComponent, computed, ref, watchEffect } from 'vue'
import useFocus from './useFocus'

export default defineComponent({
  name: 'ui-more',
  emits: {
    click: () => true
  },
  inheritAttrs: false,
  props: {
    selected: {
      default: null
    },
    isTransform: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    showArow: {
      type: Boolean,
      default: () => true
    },
    dire: {
      type: String,
      default: 'right-bottom'
    },
    floatClass: {
      type: String,
      default: ''
    }
  },
  setup(props, { attrs, emit }) {
    const vm = ref()
    const floatVM = ref()
    const showOption = useFocus(
      vm,
      computed(() => floatVM.value?.vmRef)
    )
    const clickHandler = option => {
      showOption.value = false
      emit('click', option.value)
    }

    return {
      showOption,
      floatVM,
      vm,
      attrs,
      mountel: document.body,
      clickHandler
    }
  }
})
</script>

<style scoped lang="scss">
.ui-more {
  display: inline-block;
  margin-top: 8px;
  cursor: pointer;
  font-size: 14px;
  margin-left: 4px;
}
</style>

<style lang="scss">
.ui-more-layout {
  display: inline-flex;
  align-items: center;
}

.more-float {
  transition: transform 0.3s ease, opacity 0.3s ease;
  margin-top: 9px;
  box-shadow: inset 0 0 1px rgb(255 255 255 / 90%);
  background: rgba(27, 27, 28, 0.8);
  border-radius: 4px;
  border: 1px solid #000000;
  backdrop-filter: blur(4px);
  padding: 9px 0;

  .option {
    padding: 5px 16px;
    color: #fff;
    font-size: 14px;
    white-space: nowrap;
    text-align: center;

    &.selected {
      color: var(--colors-primary-base);
    }
    &.active {
      background: var(--colors-normal-back);
      color: var(--colors-primary-base);
    }

    &:not(.active, .selected):hover {
      cursor: pointer;
      background-color: var(--colors-primary-base);
    }
  }

  transform-origin: center top;

  &:not(.show) {
    transform: translateY(0) translateX(-100%) scale(1, 0);
    opacity: 0;
  }

  &.show {
    transform: translateY(0) translateX(-100%) scale(1, 1);
    opacity: 1;
  }
}
</style>
